import { render, staticRenderFns } from "./SearchSchool.vue?vue&type=template&id=f790ab16&scoped=true"
import script from "./SearchSchool.vue?vue&type=script&lang=js"
export * from "./SearchSchool.vue?vue&type=script&lang=js"
import style0 from "./SearchSchool.vue?vue&type=style&index=0&id=f790ab16&prod&scoped=true&lang=less"
import style1 from "./SearchSchool.vue?vue&type=style&index=1&id=f790ab16&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f790ab16",
  null
  
)

export default component.exports